module.exports = __webpack_public_path__ + "static/media/MICHELL ORBE SE.13ed6ad0.png";